import { render, staticRenderFns } from "./NewUserScopeDialog.vue?vue&type=template&id=674e20bb&scoped=true&"
import script from "./NewUserScopeDialog.vue?vue&type=script&lang=js&"
export * from "./NewUserScopeDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewUserScopeDialog.vue?vue&type=style&index=0&id=674e20bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e20bb",
  null
  
)

export default component.exports